<template>
    <div class="d-flex all-after-header-box">
        <!-- Левое меню модуля -->
        <div 
            :class="{'drawer-left-wrap' : true, 'dlw-large' : (!drawerLeftMenuMini), 'drawer-menu-hover': drawerLeftMenuHover }"
            @mouseenter="LeftMenuMouseenter()"
            @mouseleave="LeftMenuMouseleave()"
        >
            <v-navigation-drawer
                absolute
                permanent
                class="drawer-menu"
                v-model="drawerLeftMenu"
            >

                <v-divider class="mr-2 ml-2"></v-divider>

                <v-list
                    nav
                    dense
                    shaped
                >

                    <v-list-group
                        v-model="group1.active" 
                        :accordion="true"
                        @input="closeOtherGroups('group1')"
                    >
                        <template v-slot:prependIcon>
                            <v-icon>far fa-books</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>{{ $t("Архив_документов") }}</v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <template v-if="years.Documents.length">
                            <template v-for="year in years.Documents">
                                <v-list-item
                                    :key="'ArchiveDocuments' + year"
                                    link
                                    :to="{ name: 'ArchiveDocuments', params: { year: year.toString() } }"
                                >
                                    <v-list-item-icon><v-icon>far fa-circle</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{ year }}</v-list-item-title>
                                </v-list-item>
                            </template>
                        </template>
                        <template v-else>
                            <v-list-item
                                key="NoArchYearDocs"
                            >
                                <v-list-item-icon><v-icon>far fa-none</v-icon></v-list-item-icon>
                                <v-list-item-title>{{ $t("Нет_архивных_документов") }}</v-list-item-title>
                            </v-list-item>
                        </template>

                    </v-list-group>

                    <v-list-group
                        v-model="group2.active" 
                        :accordion="true"
                        @input="closeOtherGroups('group2')"
                    >
                        <template v-slot:prependIcon>
                            <v-icon>far fa-mail-bulk</v-icon>
                        </template>
                        <template v-slot:activator>
                            <v-list-item-title>{{ $t("Архив_обращений") }}</v-list-item-title>
                        </template>
                        <template v-slot:appendIcon>
                            <v-icon>fas fa-chevron-down</v-icon>
                        </template>

                        <template v-if="years.Euol.length">
                            <template v-for="year in years.Euol">
                                <v-list-item
                                    :key="'ArchiveEuol' + year"
                                    link
                                    :to="{ name: 'ArchiveEuol', params: { year: year.toString() } }"
                                >
                                    <v-list-item-icon><v-icon>far fa-circle</v-icon></v-list-item-icon>
                                    <v-list-item-title>{{ year }}</v-list-item-title>
                                </v-list-item>
                            </template>
                        </template>
                        <template v-else>
                            <v-list-item
                                key="NoArchYearEuol"
                            >
                                <v-list-item-icon><v-icon>far fa-none</v-icon></v-list-item-icon>
                                <v-list-item-title>{{ $t("Нет_архивных_обращений") }}</v-list-item-title>
                            </v-list-item>
                        </template>
                    </v-list-group>
                    
                </v-list>

            </v-navigation-drawer>
        </div>

        <div class="content-box">

            <router-view :key="$route.fullPath" />
            
        </div>

    </div>
</template>

<script>
import { mapGetters} from 'vuex';
import { httpAPI/*, errorHandler*/ } from "@/api/httpAPI";

export default {
    name: "ArchiveMain",
    components: {
    },
    asyncComputed: {
        years: {
            async get() {
                let yearsObject = { Documents: [], Euol: [] }; 
                let yearsResponse = await httpAPI.get(`api/archive/years`);

                if (yearsResponse) {
                    yearsObject.Documents = yearsResponse.data.Payload[0];
                    yearsObject.Euol = yearsResponse.data.Payload[1];
                }

                return yearsObject;
            },
            default: () => ({ Documents: [], Euol: [] })
        }
    },
    computed: {
        ...mapGetters(
            {
                drawerLeftMenuMini: 'isDrawerLeftMenuMinimized'
            }),
    },
    data: () => ({
        drawerLeftMenu: true,
        drawerLeftMenuHover: false,

        group1: {
            active: false
        },
        group2: {
            active: false
        }
    }),
    methods: {
        LeftMenuMouseenter() {
            if (this.drawerLeftMenuMini)
                this.drawerLeftMenuHover = true;
        },
        LeftMenuMouseleave() {
            this.drawerLeftMenuHover = false;  
        },
        closeOtherGroups(groupName) {
            if (groupName === 'group1') {
                this.group2.active = false;
            } else if (groupName === 'group2') {
                this.group1.active = false;
            }
        }
    }
}
</script>